import { ThemeProvider } from "@mui/material";
import AppLayout from "./AppLayout";
import FileContextProvider from "./store/FileContextProvider";
import LoaderContextProvider from "./store/LoaderContextProvider";
import ScannerContextProvider from "./store/ScannerContextProvider";
import { theme } from "./themes/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <FileContextProvider>
        <ScannerContextProvider>
          <LoaderContextProvider>
            <AppLayout />
          </LoaderContextProvider>
        </ScannerContextProvider>
      </FileContextProvider>
    </ThemeProvider>
  );
}

export default App;
